import { Card, CardContent, Grid, Typography } from "@mui/material";

const KpiCard = ({ title, value, subtitle }) => (
  <Card variant="outlined" sx={{ height: "100%" }}>
    <CardContent sx={{ py: 1.5, "&:last-child": { pb: 1.5 } }}>
      <Typography variant="caption" color="text.secondary">
        {title}
      </Typography>
      <Typography variant="h6" fontWeight={700} sx={{ mt: 0.5 }}>
        {value ?? "—"}
      </Typography>
      {subtitle ? (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      ) : null}
    </CardContent>
  </Card>
);

const formatAmount = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "۰";
  return Number(value).toLocaleString("fa-IR");
};

const PartnerLeadKpiCards = ({ summary }) => {
  const s = summary || {};
  return (
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard title="کل لیدها" value={s.totalLeads ?? 0} />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard title="ثبت‌نام‌شده" value={s.registeredLeads ?? 0} />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard
          title="دارای درخواست نیروگاه"
          value={s.leadsWithProjectRequest ?? 0}
        />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard title="در حال بررسی" value={s.underReview ?? 0} />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard title="در مرحله مهرسان" value={s.mehrsanStageCount ?? 0} />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard title="در مرحله وام" value={s.loanStageCount ?? 0} />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard title="قرارداد شده" value={s.contractedCount ?? 0} />
      </Grid>
      <Grid item xs={6} sm={4} md={3}>
        <KpiCard
          title="پورسانت قابل دریافت"
          value={formatAmount(s.payableCommissionAmount)}
        />
      </Grid>
    </Grid>
  );
};

export default PartnerLeadKpiCards;
